import { Navigate } from "react-router-dom";
import { useAuth0 } from '@auth0/auth0-react';



export default function Home() {
  const { loginWithRedirect, isAuthenticated } = useAuth0();

  if (isAuthenticated) {
    return <Navigate to='/dashboard'  />;
  }

  return (
    <div className="relative bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32 h-screen">
          <svg
            className="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-white transform translate-x-1/2"
            fill="currentColor"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <polygon points="50,0 100,0 50,100 0,100" />
          </svg>

          <div className="relative pt-6 px-4 sm:px-6 lg:px-8">
            <nav
              className="relative flex items-center justify-between sm:h-10 lg:justify-start"
              aria-label="Global"
            >
              {/* <div className="flex items-center flex-grow flex-shrink-0 lg:flex-grow-0">
                <div className="flex items-center justify-between w-full md:w-auto">
                  <span className="sr-only">Workflow</span>
                  <img
                    className="h-8 w-auto sm:h-10"
                    alt="Company logo"
                    src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg"
                  />
                </div>
              </div> */}
              {/* <div className="md:ml-10 md:pr-4 space-x-8">
                {isAuthenticated ? (
                  <>
                    <NavLink
                      to={`${process.env.PUBLIC_URL}/dashboard`}
                      className="font-medium text-indigo-600 hover:text-indigo-500"
                    >
                      Dashboard
                    </NavLink>
                    <button
                      onClick={() => {
                        sessionStorage.removeItem("farm_name");
                        logout();
                      }}
                      className="font-medium text-indigo-600 hover:text-indigo-500"
                    >
                      Logout
                    </button>
                  </>
                ) : (
                  <button
                    onClick={() => loginWithRedirect()}
                    className="font-medium text-indigo-600 hover:text-indigo-500"
                  >
                    Log in
                  </button>
                )}
              </div> */}
            </nav>
          </div>

          <main className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
            <div className="sm:text-center lg:text-left">
              <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                <span className="inline-block mb-5">Sustainable Energy</span>{" "}
                <span className="text-indigo-600 inline-block mb-5">Solutions</span>
              </h1>
              {!isAuthenticated ? (
                <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                  <div className="rounded-md shadow">
                    <button
                      onClick={() => loginWithRedirect()}
                      className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 md:py-4 md:text-lg md:px-10"
                    >
                      Login
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          </main>
        </div>
      </div>
      <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
        <img
          className="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full"
          src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
          alt=""
        />
      </div>
    </div>
  );
}